import { getPortalBasename } from './metadata';

export function buildLoginRedirectUrl(redirectUrl?: string): string {
  const destination =
    redirectUrl ?? `${window.location.origin}${getPortalBasename() ?? '/'}`;
  return `/_hcms/mem/login?redirect_url=${encodeURIComponent(destination)}`;
}

export function redirectToLogin(redirectUrl?: string): void {
  window.location.href = buildLoginRedirectUrl(redirectUrl);
}
